import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import API_URL from "../../functions/config";

const ProductList = () => {
    const [products, setProducts] = useState([])
    useEffect(() => {
        getProducts();
    }, [])

    const getProducts = async () => {
        let result = await fetch(`${API_URL}/products`, {
            headers: {
                authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
            }
        });
        result = await result.json();
        setProducts(result);
    }

    const deleteProduct = async (id) => {

        let response = await fetch(`${API_URL}/product/${id}`, {
            method: "DELETE",
            headers: {
                authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
            }

        });

        let result = await response.json();

        if (result) {
            alert("Record is Deleted");
            getProducts();
        }
    };

    const searchHandle = async (event) => {
        let key = event.target.value;
        if (key) {
            let result = await fetch(`${API_URL}/search/${key}`, {
                headers: {
                    authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
                }
            });
            result = await result.json();
            if (result) {
                setProducts(result);
            }
        } else {
            getProducts();
        }
    }
    return (
        <div className="productlist">
            <h3>Product List</h3>

            <input type='text' placeholder='Search Product' className='searchbox' onChange={searchHandle} />
            <table>
                <thead>
                    <tr>
                        <th>Sr. No</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Category</th>
                        <th>Company</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        products.length > 0 ? products.map((item, index) =>

                            <tr key={item._id}>
                                <td>{index + 1}</td>
                                <td>{item.name}</td>
                                <td>${item.price}</td>
                                <td>{item.category}</td>
                                <td>{item.company}</td>
                                <td>
                                    <button onClick={() => deleteProduct(item._id)}>Delete</button>
                                    <Link to={"/update/" + item._id}>Update</Link>
                                </td>
                            </tr>
                        )

                            : <tr><td>No Product Found</td></tr>

                    }

                </tbody>
            </table>
        </div>
    )
}

export default ProductList;